// extracted by mini-css-extract-plugin
export default {"container":"index_container__KJj+H","footer":"index_footer__xZn9I"};